import React, { useState } from "react";

function CopyButton({ text, label = "Copy", className = "" }) {
  const [copied, setCopied] = useState(false);
  const classes = ["ui-copy-button", className].filter(Boolean).join(" ");

  const handleCopy = async () => {
    try {
      if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(text || "");
        setCopied(true);
        setTimeout(() => setCopied(false), 1200);
      }
    } catch (_) {
      setCopied(false);
    }
  };

  return (
    <button type="button" className={classes} onClick={handleCopy}>
      {copied ? "Copied" : label}
    </button>
  );
}

export default CopyButton;
